export function insetEnds(x1: number, y1: number, x2: number, y2: number, pad: number) {
  const dx = x2 - x1;
  const dy = y2 - y1;
  const len = Math.hypot(dx, dy);
  if (len < pad * 2) return { x1, y1, x2, y2 };
  const ux = dx / len;
  const uy = dy / len;
  return { x1: x1 + ux * pad, y1: y1 + uy * pad, x2: x2 - ux * pad, y2: y2 - uy * pad };
}
